<template>
  <span class="bulk-change" :class="{ 'is-same': !changed }">
    <template v-if="changed">
      <span class="bulk-val is-old" title="مقدار قبلی">
        <bdi class="bulk-val-num" :dir="parts(oldText).dir">{{ parts(oldText).value }}</bdi>
        <span v-if="parts(oldText).unit" class="bulk-val-unit">{{ parts(oldText).unit }}</span>
      </span>
      <b-icon icon="arrow-left" class="bulk-change-arrow" aria-hidden="true"></b-icon>
    </template>
    <span class="bulk-val" :class="changed ? 'is-new' : 'is-plain'" title="مقدار جدید">
      <bdi class="bulk-val-num" :dir="parts(newText).dir">{{ parts(newText).value }}</bdi>
      <span v-if="parts(newText).unit" class="bulk-val-unit">{{ parts(newText).unit }}</span>
    </span>
  </span>
</template>

<script>
export default {
  name: "BulkValueChange",
  props: {
    oldText: {
      default: ''
    },
    newText: {
      default: ''
    },
    changed: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    parts(text) {
      const value = String(text == null ? '' : text).trim()
      const match = value.match(/^([-+]?[\d۰-۹٬,.]+)\s*(.*)$/)
      if (match) {
        return {value: match[1], unit: match[2], dir: 'ltr'}
      }
      return {value, unit: '', dir: 'auto'}
    }
  }
}
</script>
